// extracted by mini-css-extract-plugin
module.exports = {"loading":"styles_loading__y5ZaI","flash":"styles_flash__3ISfA"};